import { render, staticRenderFns } from "./DisplayStatus.vue?vue&type=template&id=213c4270&"
import script from "./DisplayStatus.vue?vue&type=script&lang=js&"
export * from "./DisplayStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('213c4270')) {
      api.createRecord('213c4270', component.options)
    } else {
      api.reload('213c4270', component.options)
    }
    module.hot.accept("./DisplayStatus.vue?vue&type=template&id=213c4270&", function () {
      api.rerender('213c4270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/DisplayStatus.vue"
export default component.exports